import constants from "./constants";
import createAction from "sagas/createAction";

const actions = {
  GetRemainingBudgetList: (cusId) => createAction(constants.GET_REMAIN_BUDGET_LIST, { cusId }),
  GetAVGUsage: (cusId) => createAction(constants.GET_AVG_USAGE, { cusId }),
  GetPaymentHistory: (cusId, accountType) => createAction(constants.PAYMENT_HISTORY, { cusId, accountType }),
};

export default actions;
